import { cloneDeep } from "lodash";
import { storage } from "../../consts";
import { log } from "../../services";

export const SET_COGNITO_USER = "app/auth/SET_COGNITO_USER";
export const SET_CHALLENGED_USER = "app/auth/SET_CHALLENGED_USER";
export const RESET_COGNITO_USER = "app/auth/RESET_COGNITO_USER";
export const SET_USER_LOGIN_ERRORS = "app/auth/SET_USER_LOGIN_ERRORS";
export const RESET_USER_LOGIN_ERRORS = "app/auth/RESET_USER_LOGIN_ERRORS";
export const SET_IS_LOGOUT = "app/auth/SET_IS_LOGOUT";
export const SET_IS_LOGGED_IN = "app/auth/SET_IS_LOGGED_IN";
export const SET_IS_MANDATORY_DATA_FETCHED = "app/auth/SET_IS_MANDATORY_DATA_FETCHED";

const getItemFromStorage = (storageItem) => {
  const itemFromStorage = localStorage.getItem(storageItem);
  const itemParsed = itemFromStorage ? JSON.parse(itemFromStorage) : null;

  return itemParsed;
};

const initialState = {
  challengedUser: null,
  cognitoUser: getItemFromStorage(storage.COGNITO_USER),
  loginErrors: getItemFromStorage(storage.LOGIN_ERRORS) ?? [],
  isLogout: false,
  isLoggedIn: false,
  isMandatoryDataFetched: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_COGNITO_USER: {
      const clonedState = cloneDeep(state);

      if (!clonedState?.cognitoUser) {
        try {
          delete action.payload.storage;
          localStorage.setItem(storage.COGNITO_USER, JSON.stringify(action.payload));
        } catch (e) {
          log.error("Cognito user set error", e);
        }

        return {
          ...clonedState,
          cognitoUser: action.payload
        };
      }
      return { ...clonedState };
    }

    case SET_CHALLENGED_USER: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        challengedUser: action.payload
      };
    }

    case RESET_COGNITO_USER: {
      const clonedState = cloneDeep(state);
      localStorage.removeItem(storage.COGNITO_USER);
      return {
        ...clonedState,
        cognitoUser: null
      };
    }

    case SET_USER_LOGIN_ERRORS: {
      const clonedState = cloneDeep(state);

      const userLoginErrors = action.payload;
      const username = userLoginErrors.username;

      const newLoginErrors = [
        ...clonedState.loginErrors.filter((errors) => errors.username !== username),
        userLoginErrors
      ];

      localStorage.setItem(storage.LOGIN_ERRORS, JSON.stringify(newLoginErrors));

      return {
        ...clonedState,
        loginErrors: newLoginErrors
      };
    }

    case RESET_USER_LOGIN_ERRORS: {
      const clonedState = cloneDeep(state);

      const username = action.payload;

      const newLoginErrors = [
        ...clonedState.loginErrors.filter((errors) => errors.username !== username)
      ];

      localStorage.setItem(storage.LOGIN_ERRORS, JSON.stringify(newLoginErrors));

      return {
        ...clonedState,
        loginErrors: newLoginErrors
      };
    }

    case SET_IS_LOGOUT: {
      const clonedState = cloneDeep(state);
      return {
        ...clonedState,
        isLogout: action.payload
      };
    }

    case SET_IS_LOGGED_IN: {
      const clonedState = cloneDeep(state);
      return {
        ...clonedState,
        isLoggedIn: action.payload
      };
    }

    case SET_IS_MANDATORY_DATA_FETCHED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isMandatoryDataFetched: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export function setCognitoUser(cognitoUser) {
  return { type: SET_COGNITO_USER, payload: cognitoUser };
}

export function setChallengedUser(challengedUser) {
  return { type: SET_CHALLENGED_USER, payload: challengedUser };
}

export function resetCognitoUser(cognitoUser) {
  return {
    type: RESET_COGNITO_USER,
    payload: cognitoUser
  };
}

export function setUserLoginErrors(userLoginErrors) {
  return {
    type: SET_USER_LOGIN_ERRORS,
    payload: userLoginErrors
  };
}

export function resetUserLoginErrors(username) {
  return {
    type: RESET_USER_LOGIN_ERRORS,
    payload: username
  };
}

export function setIsLogout(isLogout) {
  return { type: SET_IS_LOGOUT, payload: isLogout };
}

export function setIsLoggedIn(isLoggedIn) {
  return { type: SET_IS_LOGGED_IN, payload: isLoggedIn };
}

export function setIsMandatoryDataFetched(isFetched) {
  return { type: SET_IS_MANDATORY_DATA_FETCHED, payload: isFetched };
}
